import React from 'react'
import ReactDOM from 'react-dom/client'
import './App.scss'
import './Lib.scss'
import 'react-dates/initialize'
import './assets/css/react_dates_overrides.scss'
import './assets/css/react_phone_number_input_overwrite.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import { store } from './redux/store'

const rootElement = document.getElementById('dtravel-widget') as HTMLElement
const root = ReactDOM.createRoot(rootElement)

// const hostId = '1d4ec56c-c390-426f-aee8-11f284982878'
// const propertyId = '3852'
root.render(
  <Provider store={store}>
    {/*<React.StrictMode>*/}
    {/* <App hostId={hostId} propertyId={propertyId} /> */}
    <App hostId={rootElement.dataset.hostid} propertyId={rootElement.dataset.propertyid} />
    {/*</React.StrictMode>*/}
  </Provider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
